import React, { useEffect, useRef, useState } from "react";
import TextField, { TextFieldProps } from "./TextField";

const ControlledTextField: React.FC<TextFieldProps> = (props) => {
	const { onChange, value, ...otherProps } = props;
	const [cursor, setCursor] = useState<number | null>(null);
	const ref = useRef<HTMLInputElement>(null);

	useEffect(() => {
		ref.current?.setSelectionRange(cursor, cursor);
	}, [ref, cursor, value]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setCursor(e.target.selectionStart);
		onChange?.(e);
	};

	return (
		<TextField
			inputRef={ref}
			onChange={handleChange}
			value={value}
			{...otherProps}
		/>
	);
};

export default ControlledTextField;